export default {
  allTasksNEvents: [],
  tasks: [],
  events: [],
  todayTasks: [],
  selectedTask: null,
  error: false,
  errorMessage: '',
  RepeatOptions: [],
  Classes: [],
  Priorities: [],
  Types: [],
  projects: [],
  earnPoints: false,
  pointsEarned: 0,
  pendingTasks: [],
  notificationsTypes: [],
  taskPerDate: {}
}